<template>
  <StandardFlexBox
    width="100%"
    direction="row"
    align_items="center"
    :no_wrap="true"
    gap="4px"
  >
    <TIcon
      v-if="icon"
      class="input-and-source-field-icon-shrink"
      :name="icon"
      color="black"
      size="48"
    />

    <StandardFlexBox
      direction="column"
      class="input-and-source-field-grow"
    >
      <div class="input-and-source-input-dropdown">
        <div class="input-and-source-field-grow">
          <DisableableInputField
            :label="label"
            align="left"
            :background_color="getColor(background_color)"
            :foreground_color="getColor(foreground_color)"
            :value="val"
            :is_disabled="read_only"
            :input_type="input_type"
            :input_mode="input_mode"
            @change="$emit('change', $event)"
          />
        </div>
        <DropDownOutlinedFlat
          v-if="units"
          label="Unit"
          :is_disabled="true"
          :options="units"
          :value="units[0]"
          width="70"
          font_size="10"
          :background_color="getColor(background_color)"
          :foreground_color="getColor(foreground_color)"
        />
      </div>
      <div class="input-and-source-field-icon-source">
        <TTooltip
          v-if="showTakeoverFilter"
          value="Set to Filter (CTRL + click to add as new Filterline)"
          >
          <TIcon size="16" 
              name="filter" style="cursor: pointer;"
              @click.native.prevent.stop="$emit('takeoverFilter', $event)"
          />
        </TTooltip>
        <TIcon 
          class="input-and-source-field-icon-shrink"
          name="link" 
          small 
          :color="source_val 
            ? getTranspHexColor(getColor(foreground_color), 0.8) 
            : getTranspHexColor(getColor(foreground_color), 0.3)" 
        /> 
        <TTooltip :value="source_val">
          <TText 
            :text="source_val || '-'" 
            size="8" 
            :color="source_val 
              ? getTranspHexColor(getColor(foreground_color), 0.8) 
              : getTranspHexColor(getColor(foreground_color), 0.3)" 
            max_lines="1" 
          />
        </TTooltip>
      </div>
    </StandardFlexBox>
  </StandardFlexBox>
</template>

<script>
import StandardFlexBox from '@/components/StandardComponents/StandardFlexBox.component.vue';
import DisableableInputField from '@/components/WorkPackageWIP/DisableableInputField.component.vue';
import DropDownOutlinedFlat from '@/components/WorkPackageWIP/DropDownOutlinedFlat.component.vue';
import TIcon from '@/components/Taktify/TIcon.component.vue';
import TTooltip from '@/components/Taktify/TTooltip.component.vue';
import { TColor } from '@/mixins/TColor.mixin.js';

export default {
  components: {
    StandardFlexBox,
    DisableableInputField,
    DropDownOutlinedFlat,
    TIcon,
    TTooltip,
  },

  mixins: [
    TColor,
  ],

  props: [
    'val',
    'source_val',
    'label',
    'read_only',
    'icon',
    'units',
    'input_type',
    'input_mode',
    'foreground_color',
    'background_color',
    'showTakeoverFilter',
  ],
}
</script>

<style lang="css" scoped>
.input-and-source-field-icon-shrink {
  flex-shrink: 0;
}
.input-and-source-field-grow {
  flex-grow: 1;
}
.input-and-source-input-dropdown {
  display: flex; 
  grid-gap: 8px; 
  width: 100%;
}
.input-and-source-field-icon-source {
  display: flex; 
  align-items: center; 
  grid-gap: 2px;
  padding-top: 2px;
}
</style>
